import style from  './Map.module.css'
import { MapFilterSelect } from '../Select/MapFilterSelect';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveTag } from '../../Redux/Slices/Cables';
import CMap from './Map';
import { openOrClose } from '../../Redux/Slices/Select/Select';

export function MapContainer() {
    const vendorActiveTag = useSelector(state => state.vendor.vendorActiveTag)
    const cableActiveTag = useSelector(state => state.cables.cableActiveTag)
    const cablesTags = useSelector(state => state.cables.cablesTags)
    const MapFilterSelecttState = useSelector((state) => state.select.MapFilterSelect)

    const dispatch = useDispatch()

    return <div className={style.containers}>
        <div className={`${style.map} map`}>
            {/* Cables Select */}
            <MapFilterSelect isOpen={MapFilterSelecttState} setIsOpen={() => dispatch(openOrClose('MapFilterSelect'))} options={cablesTags} value={cableActiveTag} setValue={(item) => dispatch(setActiveTag(item))}/>
            {/* Map */}
            <CMap valueFilter={cableActiveTag} valueSelect={vendorActiveTag} />
        </div>
    </div>
}
